import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getStateFromQueryString, writeStateToUrl } from '../../common/query-string-helper';
import { apiSlice } from '../api-slice'

interface SearchOptions {
    term: string;
    searchBy: string;
    sortBy: string;
    operaFilter: string;
}

const queryStringState = getStateFromQueryString();

const initialState: SearchOptions = {
    term: queryStringState?.term || "",
    searchBy: queryStringState?.searchBy || "All",
    sortBy: queryStringState?.sortBy || "Title",
    operaFilter: queryStringState?.operaFilter || "",
};


const searchOptionsSlice = createSlice({
    name: 'searchOptions',
    initialState,
    reducers: {

        setSearchTerm(state, action: PayloadAction<string>) {
            state.term = action.payload;
        },
        setSearchBy(state, action: PayloadAction<string>) {
            state.searchBy = action.payload;
        },
        setSortBy(state, action: PayloadAction<string>) {
            state.sortBy = action.payload;
        },
        setSearchContext(state, action: PayloadAction<{ term: string, filter: string }>) {
            state.term = action.payload.term;
            state.searchBy = action.payload.filter;
            // Clear out single-opera filter query param after first user search
            state.operaFilter = "";
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(apiSlice.endpoints.fetchResults.matchPending, (state) => {
            writeStateToUrl(state.searchBy, state.term, state.sortBy);
        })
    }
  
});

export const { setSearchTerm, setSearchBy, setSortBy, setSearchContext } = searchOptionsSlice.actions;
export default searchOptionsSlice.reducer;
